module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.94dac78.woff";